import one from './presets/one';
import three from './presets/three';
import two from './presets/two';
/**
 * Columns presets.
 */
export const presets = [one, two, three, three];
